<script>
import Toasts from './Components/Toasts.vue';
import ConfirmDialog from './Components/ConfirmDialog.vue';

export default {
    name: 'App',
    components: { Toasts, ConfirmDialog },
};
</script>

<template>
    <router-view />
    <Toasts />
    <ConfirmDialog />
</template>
